import React from 'react';
import { Box, Typography } from '@mui/material';
import { portalMetricTileSx } from '../../../styles/portalSurfaces';
import { formatPercentDisplay, normalizeMetric } from '../utils/metricFormatters';

const retentionStages = [
  { label: 'Day 1', key: 'd1' },
  { label: 'Day 7', key: 'd7' },
  { label: 'Day 30', key: 'd30' },
  { label: 'WAU/MAU', key: 'wauMau' },
];

const emptyStage = { count: 0, totalCount: 0, percentage: 0 };

const RetentionRate = ({ metrics }) => {
  const retentionData = metrics?.retention || {};
  const retentionRateData = retentionStages.map((stage) => {
    const raw = retentionData[stage.key];
    const stageData = normalizeMetric(raw) || emptyStage;
    const percentage = Number(stageData.percentage) || 0;
    return {
      label: `${stage.label} (${stageData.count})`,
      value: formatPercentDisplay(percentage),
    };
  });

  return (
    <Box sx={{ p: 1.5, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 'medium' }}>
          Retention
        </Typography>
      </Box>

      <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1.25 }}>
        {retentionRateData.map((item) => (
          <Box
            key={item.label}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              ...portalMetricTileSx,
              py: 1.25,
            }}
          >
            <Box
              sx={{ display: 'flex', alignItems: 'center', gap: 1.25, flex: 1, minWidth: 0, mr: 1 }}
            >
              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: 400,
                  lineHeight: 1.25,
                  flex: 1,
                }}
              >
                {item.label}
              </Typography>
            </Box>
            <Typography sx={{ fontSize: 12, fontWeight: 600, flexShrink: 0 }}>
              {item.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default RetentionRate;
